import React, { ReactElement } from 'react';
import { Container, Bar, Progress, Pointer } from './styles';
type props = {
  steps: number
  progress: number
  isOne?: boolean
  stepStatus?: string};
export default function ProgressBar(props: Readonly<props>): ReactElement {
  const width = props.progress * (100 / props.steps);
  let progressWidth = width;
  if (props.isOne) {
    progressWidth = props.stepStatus === 'Realizada' ? 100 : width / 2;
  }
  return (
    <Container>
      {!props.isOne &&
        <Pointer pointerWidth={width - 2}>
          <span>
            {props.progress || ''}
          </span>
        </Pointer>
        }
        <Bar>
            <Progress progressWidth={progressWidth}></Progress>
        </Bar>
    </Container>
  );
}
